var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpoOriginal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.654 48.883c1.051-1.534 2.197-1.727 3.127-1.727s2.475.193 3.527 1.727C75.556 60.12 89.173 82.512 99.22 99.035c6.555 10.767 11.586 19.043 12.622 20.095 3.874 3.952 9.189 1.489 12.278-2.995 3.039-4.412 3.88-7.512 3.88-10.817 0-2.253-44.052-83.515-48.486-90.28C75.25 8.534 73.856 6.89 66.56 6.89h-5.469c-7.28 0-8.331 1.644-12.599 8.148C44.058 21.803 0 103.065 0 105.313c0 3.31.847 6.41 3.892 10.822 3.088 4.484 8.403 6.947 12.278 2.99 1.03-1.053 6.061-9.323 12.615-20.095 10.047-16.518 23.62-38.91 31.874-50.153z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpoOriginal);
export default __webpack_public_path__ + "static/media/expo-original.78e9ce8cc883da1daaa42bcda6adca4f.svg";
export { ForwardRef as ReactComponent };